<dx-box width="100%" height="100%" direction="col" class="search-toolbar-container cc-search-toolbar-container">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <div class="toolbar-item-container" *ngIf="visible">
                <div class="toolbar-button-container">
                    <div class="button-container" *ngFor="let button of searchButtons">
                        <dx-button
                            [ngClass]="{ 'search-button': !button.selected, 'selected-search-button': button.selected }"
                            type="normal"
                            [stylingMode]="'text'"
                            [icon]="button.icon"
                            [hint]="button.hint"
                            [visible]="button.visible"
                            (onClick)="onSearchItemClick(button)"
                        ></dx-button>
                    </div>
                    <div class="button-container">
                        <dx-button
                            class="selected-search-button"
                            *ngIf="isSearchPanelAvailable"
                            type="default"
                            [stylingMode]="'text'"
                            icon="fas fa-history"
                            hint="Click to open previous searched result"
                            (onClick)="openLastSearchedPanel()"
                        ></dx-button>
                    </div>
                </div>
                <div class="menu-button-container">
                    <div class="button-container" id="favouriteButton">
                        <dx-button
                            [icon]="bookmarkIcon"
                            [ngClass]="{
                                'search-button': !showBookmarkPopover,
                                'selected-search-button': showBookmarkPopover
                            }"
                            type="default"
                            [stylingMode]="'text'"
                            (onClick)="openBookmarkPopover()"
                        ></dx-button>

                        <dx-popover
                            target="#favouriteButton"
                            position="bottom"
                            [height]="800"
                            [width]="250"
                            [(visible)]="showBookmarkPopover"
                        >
                            <div *dxTemplate="let data of 'content'">
                                <div class="favourite-container">
                                    <div class="title-content">
                                        <div class="title"><h3>Bookmarks</h3></div>
                                        <div class="button-content">
                                            <dx-button
                                                icon="fas fa-cog"
                                                hint="Add Bookmarks"
                                                (onClick)="addBookmarks()"
                                            ></dx-button>
                                        </div>
                                    </div>
                                    <div class="popover-item-container cc-popover-item-container">
                                        <dx-tree-view
                                            #bookmarkTree
                                            width="100%"
                                            height="100%"
                                            dataStructure="plain"
                                            itemTemplate="itemTemplate"
                                            [expandNodesRecursive]="false"
                                            [items]="bookmarkItems"
                                            (onItemClick)="onBookmarkItemSelection($event)"
                                        >
                                            <div *dxTemplate="let item of 'itemTemplate'">
                                                <div class="tree-item-container">
                                                    <div
                                                        class="tree-icon"
                                                        [ngClass]="{ 'tree-disabled': item.disable }"
                                                    >
                                                        <i [class]="item.icon"></i>
                                                    </div>
                                                    <div
                                                        class="tree-label"
                                                        [ngClass]="{ 'tree-disabled': item.disable }"
                                                    >
                                                        {{ item.text }}
                                                    </div>
                                                </div>
                                            </div>
                                        </dx-tree-view>
                                    </div>
                                </div>
                            </div>
                        </dx-popover>
                    </div>
                    <div class="button-container" id="menuButton">
                        <dx-button
                            type="default"
                            icon="fas fa-ellipsis-h"
                            [ngClass]="{ 'selected-search-button': showMenu, 'search-button': !showMenu }"
                            [stylingMode]="'text'"
                            (onClick)="openSideMenu()"
                        ></dx-button>

                        <dx-popover
                            target="#menuButton"
                            position="right"
                            width="100%"
                            [(visible)]="showMenu"
                            (onShowing)="onPopoverShowing($event)"
                        >
                            <div *dxTemplate="let data of 'content'" class="top-menu-content">
                                <app-top-navigation-menu
                                    [topMenuItems]="menuItems"
                                    [selectedNode]="selectedNode"
                                    (onNavigationChanged)="onNavigationChanged($event)"
                                ></app-top-navigation-menu>
                            </div>
                        </dx-popover>
                    </div>
                </div>
            </div>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <app-current-owner-quick-search
                #ownerSearch
                *ngIf="selectedButton.name === 'owner'"
                [searchText]="ownerSearchedText"
                [lastSearchedText]="lastOwnerSearchText"
                [searchResults]="ownerSearchResult"
                (saveSearchResults)="saveOwnerSearchResults($event)"
                (onTextSearched)="onOwnerTextSearched($event)"
            ></app-current-owner-quick-search>
            <app-community-quick-search
                #communitySearch
                *ngIf="selectedButton.name === 'community'"
                [searchText]="communitySearchedText"
                [lastSearchedText]="lastCommunitySearchText"
                [searchResults]="communitySearchResult"
                (saveSearchResults)="saveCommunitySearchResults($event)"
                (onTextSearched)="onCommunityTextSearched($event)"
            ></app-community-quick-search>
            <app-navigation-quick-search *ngIf="selectedButton.name === 'navigation'"></app-navigation-quick-search>
        </div>
    </dxi-item>
</dx-box>

<app-bookmark-manager
    *ngIf="showAddBookmarkPopup"
    [visible]="showAddBookmarkPopup"
    [sideMenuItems]="bookmarkMenuItems"
    (onClose)="onBookmarkClose($event)"
></app-bookmark-manager>

<dx-load-panel *ngIf="loadingVisible" [position]="{ of: 'body' }" [visible]="loadingVisible"></dx-load-panel>
